import { OutlinedUserSquare } from '@/components/elements/svgIcon/outlined';
import { LoginModal } from '@/components/modal/LoginModal';
import { useScrollPosition } from '@/hooks/useScreenPosition';
import { RoleViewEnum } from '@/interfaces/profile.interface';
import { Button } from '@mui/material';
import cookieCommons from 'common/cookieCommons';
import createVCard from 'common/createVCard';
import { PATH_NAME } from 'configs/pathName';
import BaseLayout from 'layouts';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import { PendingFollowMe } from '../../components/elements/profile';
import SearchHeader from '../../components/header/SearchHeader';
import { BIZ_SHOW_HEADER_ON_SCROLLING_POINT } from '../../constant/numericParams';
import { IPersonalProfileLayout } from '../../interfaces/components/layout.interface';

const accessToken = cookieCommons.getAccessToken() as string;

const ProfileLayout: React.FC<IPersonalProfileLayout> = ({
  children,
  classname,
  roleView = 'owner',
  isDisplayed = true,
  identify = '',
  childrenClassname = '',
  showHeader = false,
  showSearchHeader = true,
  // props for header and PendingFollowMe
  info,
  data,
  slug,
  handleShare,
  handleToggleBottomModal,
  uid,
  refectAfterChangeInformation,
}) => {
  const router = useRouter();
  const isProfilePage = router.pathname.includes('user');
  const [isShowHistorySearch, setIsShowHistorySearch] =
    useState<boolean>(false);

  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [loginModal, setLoginModal] = useState<boolean>(false);

  const showHistorySearch = useCallback(() => {
    setIsShowHistorySearch(false);
  }, [setIsShowHistorySearch]);

  useScrollPosition(({ scrollY }) => {
    if (scrollY > BIZ_SHOW_HEADER_ON_SCROLLING_POINT) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  });

  useEffect(() => {
    window.addEventListener('click', showHistorySearch);
    return () => window.removeEventListener('click', showHistorySearch);
  }, [showHistorySearch]);

  return (
    <>
      <BaseLayout>
        {isProfilePage && (
          <div
            className={[
              'fixed right-4 z-[100] mb-4 block md:hidden',
              roleView !== RoleViewEnum.Owner && isDisplayed
                ? 'bottom-[130px]'
                : 'bottom-[70px]',
            ].join(' ')}
          >
            <Button
              onClick={() => createVCard(data)}
              variant="high_emphasis_v2"
              startIcon={<OutlinedUserSquare />}
            >
              Lưu danh bạ
            </Button>
          </div>
        )}

        {roleView !== RoleViewEnum.Owner && isDisplayed && (
          <div
            className="bg-blue-gradient-2 fixed bottom-16 z-10 block w-full cursor-pointer py-3 text-center text-[1rem] text-white md:hidden"
            onClick={() => {
              if (accessToken) {
                router.push({
                  pathname: PATH_NAME.PROFILE,
                  query: {
                    uid: cookieCommons.getQbankUserId(),
                  },
                });
              } else {
                setLoginModal(true);
              }
            }}
          >
            Xây dựng trang cá nhân của bạn
          </div>
        )}
        {/* header appear on scroll */}
        {/* {showHeader && (
          <div
            className={`sticky top-0 z-10 h-0 w-full transition-all duration-500 ease-out ${
              isScrolled ? '' : '-translate-y-[170px]'
            }`}
          >
            <Header
              roleView={roleView}
              info={info}
              imgSrc={data?.profiles?.avatar}
              fullName={info?.fullName}
              userName={slug}
              handleShare={handleShare}
              handleToggleBottomModal={handleToggleBottomModal}
              hasBlueTick={data?.profiles?.hasBlueTick}
            />
          </div>
        )} */}
        {/* search header: desktop only */}
        {data?.profiles.pendingFollowMe && (
          <PendingFollowMe
            data={info}
            uid={uid}
            refectAfterChangeInformation={refectAfterChangeInformation}
          />
        )}
        <div className="hidden sm:block">
          {showSearchHeader && !data?.profiles.pendingFollowMe && (
            <SearchHeader
              setIsShowHistorySearch={setIsShowHistorySearch}
              isShowHistorySearch={isShowHistorySearch}
            />
          )}
        </div>
        {/* history search */}
        {isShowHistorySearch && (
          <div className="fixed right-0 top-0 z-50 hidden min-h-full min-w-[100vw] bg-black bg-opacity-25 sm:block"></div>
        )}
        <div className={`${childrenClassname} mx-auto w-full max-w-container`}>
          {children}
        </div>
      </BaseLayout>

      <LoginModal toggle={setLoginModal} isVisible={loginModal} />
    </>
  );
};

export default ProfileLayout;
